import * as React from 'react';
import { Link } from 'react-router-dom';

const StoreRelated = (props) => {
	return (
		<div className="item">
			<Link to={`/store-detail/${props.cate_slug}/${props.store.post_id}/${props.store.post_name}`}>
				<img src={require('../../img/img-maskrelate.png')}
				     style={{ background: `url(${props.store.post_thumbnail.link})  no-repeat top left/cover` }}/>
				<h4>{props.store.post_title}</h4>
			</Link>
		</div>
	);
};

export default StoreRelated;



// WEBPACK FOOTER //
// ./src/containers/component/StoreRelated.tsx